﻿import md5 from 'crypto-js/md5';

export function generateUserHash(): string {
    const userAgent = navigator.userAgent;
    const ip = 'unknown'; // or replace with the real IP via an API
    return md5(userAgent + ip).toString();
}
